import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const PlanProtectedRoute = ({ children }) => {
  const { subscriptionPlan } = useSelector((state) => state.settings);
  const planName = subscriptionPlan?.planName;

  if (planName === 'Basic') {
    return <Navigate to="/admin/unauthorized" replace />;
  }

  return children;
};

export default PlanProtectedRoute;